
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./app.ts"
import * as amdModule1 from "./config/environment.ts"
import * as amdModule2 from "./registry.ts"
import * as amdModule3 from "./router.ts"
import * as amdModule4 from "./services/docs.ts"
import * as amdModule5 from "./services/selected.ts"
import * as amdModule6 from "./utils.ts"
import * as amdModule7 from "./services/page-title.js"
import * as amdModule8 from "./templates/application.gts"
import * as amdModule9 from "./controllers/application.ts"
import * as amdModule10 from "./routes/application.ts"
import * as amdModule11 from "./routes/index.ts"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"tutorial/app": amdModule0,
"tutorial/config/environment": amdModule1,
"tutorial/registry": amdModule2,
"tutorial/router": amdModule3,
"tutorial/services/docs": amdModule4,
"tutorial/services/selected": amdModule5,
"tutorial/utils": amdModule6,
"tutorial/services/page-title": amdModule7,
"tutorial/templates/application": amdModule8,
"tutorial/controllers/application": amdModule9,
"tutorial/routes/application": amdModule10,
"tutorial/routes/index": amdModule11,
  },
  exportFastbootModules
);
